export default __webpack_public_path__ + "static/media/feintattack6.4db27b8f.png";